import { HTTP as http } from '../../http'

const PREFIX = '/client'

export default {
    get: () => {
        return http.post(PREFIX+'/get')
    },

    getListEmployeeTypes: () => {
        return http.post(PREFIX+'/getListEmployeeTypes')
    },

    create: (data) => {
        return http.post(PREFIX+'/register', data)
    },

    confirmRegisterCode: (data) => {
        return http.post(PREFIX+'/register/confirm', data)
    },

    resendRegisterCode: (data) => {
        return http.post(PREFIX+'/register/resend-code', data)
    },

    authenticate: (data) => {
        return http.post(PREFIX+'/authenticateJson', data)
    },
    logout: () => {
        return http.get('/logout')
    },
    acceptTerms: () =>{
        return http.get(PREFIX+'/accept-terms')
    },
    checkClientApproved: () => {
        return http.get(PREFIX+'/check-approved')
    },

    forgotPassword: (data) => {
        return http.post('/forget-password', data)
    },
}
